'use strict';

exports.__esModule = true;
exports.striptags = striptags;
exports.contains = contains;
exports.validateEmail = validateEmail;
var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};

function striptags(string) {
  var strippedString = string.replace(/(<([^>]+)>)/ig, '');
  return strippedString;
}

function contains(arr, value) {
  for (var key = 0; key < arr.length; key++) {
    if (arr[key].id === value) {
      return true;
    }
  }
  return false;
}

function validateEmail(value) {
  if (!isEmpty(value) && !/^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,20})$/i.test(value)) {
    return {
      valid: false,
      error: 'Please enter valid email'
    };
  }

  if (isEmpty(value)) {
    return {
      valid: false,
      error: 'Please enter your email'
    };
  }

  return {
    valid: true
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/index.js
// module id = 125
// module chunks = 0